import axios from "axios";

let language = document.documentElement.lang.toUpperCase();

export default {
    get(iSO) {
        const API = `/api/catalogs/States/country/${iSO}/language/${language}`;

        return axios.post(API);
    },
    create(todo) {}
};